import React from 'react'
import { formatToPrice } from '../../../../../utility/prettifynumber'
import { toast } from 'react-toastify'
import { FiCopy } from 'react-icons/fi'
import { PaymentMethod } from '../../../../../config/enums'
import constants from '../../../../../config/constants'

type Props = {
  payMethod: PaymentMethod
  totalAmount: number
  orderNumber: string
}

const PaymentMethodDetails = ({
  payMethod,
  totalAmount,
  orderNumber
}: Props) => {
  return (
    <>
      {payMethod === PaymentMethod.cash && (
        <>
          <p className="text-dark">
            Please prepare cash{' '}
            <b className="text-primary">{formatToPrice(totalAmount)}</b> to
            BigMochi for{' '}
            <b className="text-primary">
              Order # {orderNumber}{' '}
              <FiCopy
                onClick={() => {
                  navigator.clipboard.writeText(orderNumber)
                  toast.success('Copied!', {
                    autoClose: 3000
                  })
                }}
                className="text-primary"
              />
            </b>{' '}
            and visit us at:
          </p>
          <p className="text-dark">
            <b>Homekeeper Bukit Timah Shopping Centre Branch</b>
            <br />
            170 Upper Bukit Timah Road #04-60
            <br />
            Bukit Timah Shopping Centre
            <br />
            Singapore 588179
          </p>
          <p className="text-dark">Open only on Sunday from 9am-6pm</p>
        </>
      )}

      {(payMethod === PaymentMethod.paynow ||
        payMethod === PaymentMethod.dash) && (
        <>
          <p className="text-dark">
            Please send{' '}
            <b className="text-primary" data-testid="amountPayable">
              {formatToPrice(totalAmount)}
            </b>{' '}
            to BigMochi for{' '}
            <b className="text-primary">
              Order # {orderNumber}{' '}
              <FiCopy
                onClick={() => {
                  navigator.clipboard.writeText(orderNumber)
                  toast.success('Copied!', {
                    autoClose: 3000
                  })
                }}
                className="text-primary"
              />
            </b>{' '}
            and and don’t forget to indicate the order # in the payment message.
          </p>
          <dl data-testid="bankDetails">
            <dt>Merchant name</dt>
            <dd className="text-dark" data-testid="accountName">
              {constants.bigMochiBankAccountName}
            </dd>
            {payMethod === PaymentMethod.paynow ? (
              <>
                <dt>Paynow UEN</dt>
                <dd className="text-dark" data-testid="accountNumber">
                  {constants.paymentMethod.payNow}{' '}
                  <FiCopy
                    onClick={() => {
                      navigator.clipboard.writeText(
                        constants.paymentMethod.payNow
                      )
                      toast.success('Copied!', {
                        autoClose: 3000
                      })
                    }}
                    className="text-primary"
                  />
                </dd>
              </>
            ) : (
              <>
                <dt>Phone number</dt>
                <dd className="text-dark">
                  <span data-testid="dashPhoneNumber">
                    {constants.paymentMethod.dash}
                  </span>{' '}
                  <FiCopy
                    onClick={() => {
                      navigator.clipboard.writeText(
                        constants.paymentMethod.dash
                      )
                      toast.success('Copied!', {
                        autoClose: 3000
                      })
                    }}
                    className="text-primary"
                  />
                </dd>
              </>
            )}
          </dl>
        </>
      )}
    </>
  )
}

export default PaymentMethodDetails
